// extracted by mini-css-extract-plugin
module.exports = {"pictures_walls_container":"PicturesWall_pictures_walls_container__16d_6"};